<script>
	const _ = require('underscore');
	const moment = require('moment');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const metadata = require('core/metadata');
	const fireEvent = analyticsUtilities.fireEvent;
	const { HOMEPAGE_CLICK, PAGE_VIEW } = analyticsUtilities.events;
	const { isHostedLink } = require('utilities/urlUtilities');

	const promoNewsItems = metadata.promoNewsItems;

	export default {
		components: {
			'whats-new-modal': require('components/whats-new-modal.vue').default
		},
		modelData: ['userContext'],
		data() {
			return {
				headline: promoNewsItems && promoNewsItems.headline,
				loadedCards: 0,
				lazyLoadingIncrement: 3,
				lazyObserver: undefined
			};
		},
		computed: {
			news() {
				let cards = promoNewsItems && promoNewsItems.cards;
				let items = [];
				let today = moment().startOf('day');
				if (cards && cards.length) {
					cards.forEach(newsItem => {
						let start = newsItem.start_date;
						let end = newsItem.end_date;
						let hosted = isHostedLink(newsItem.link);

						if ((start && today < moment(start)) || (end && today > moment(end))) {
							return;
						}

						items.push(
							_.assign({}, newsItem, {
								target: !hosted ? '_blank' : undefined,
								imgUrl: newsItem.img
							})
						);
					});
				}

				items.sort((a, b) => {
					return a.order - b.order;
				});

				return items;
			}
		},
		methods: {
			onNewsItemClick(item) {
				if (item && item.id) {
					fireEvent(HOMEPAGE_CLICK, {
						loc: 'authenticated-homepage',
						path: item.link,
						nid: item.id,
						order: item.order
					});
				}
			},
			onFindContentButtonClick() {
				fireEvent(HOMEPAGE_CLICK, {
					loc: 'authenticated-homepage-find-content'
				});
			},
			onLazyLoaded(entries) {
				const lastLoadedIndex = this.loadedCards - 1;
				const increment = this.lazyLoadingIncrement;
				const lastVisibleItemIndex = entries.reduce((acc, { isIntersecting, target }) => {
					if (isIntersecting) {
						acc = Number(target.getAttribute('loader-index'));
					}

					return acc;
				}, lastLoadedIndex);

				if (lastVisibleItemIndex > lastLoadedIndex) {
					const incrementMultiplier = Math.ceil((lastVisibleItemIndex - lastLoadedIndex) / increment);
					this.loadedCards += incrementMultiplier * increment;
				}
			}
		},
		mounted() {
			let userContext = this.userContext;

			if (userContext && !userContext.classCode) {
				fireEvent(PAGE_VIEW, {
					path: '/',
					loc: 'authenticated-homepage'
				});
			}

			this.lazyObserver = new IntersectionObserver(this.onLazyLoaded, {
				threshold: 0.1
			});
		},
		beforeDestroy() {
			this.lazyObserver.disconnect();
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	$news-card-width: 14rem;
	$new-card-double-width: $news-card-width * 2+2.25rem;

	.authenticated-homepage {
		.promo-bar {
			background-color: $c-white;
			border-bottom: 1px solid $c-grey;

			.wrapper {
				padding: 0.5rem 1rem;
			}

			.search-promo {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				flex-wrap: wrap;

				> * {
					margin: 0.5rem 0;
				}

				img {
					display: none;
				}

				.search-promo-text {
					flex: 1;
					color: $c-blue;
					font-weight: bold;
					padding: 0 2rem;
				}

				.start-search-button {
					border-color: $c-blue;
					color: $c-blue;
					padding: 0.5rem 2.5rem;

					&:hover {
						color: $c-white;
					}
				}
			}
		}

		h1.news-headline {
			font-size: 32px;
			font-weight: 200;
			margin: 1rem 0;
		}

		.card-wrapper {
			overflow-x: hidden;
			width: 100%;
			padding: 0 20px 0 20px;

			.news-card-layout {
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				margin: 2rem -20px 0 -20px;

				.news-card {
					position: relative;
					background-color: $c-grade-unanswered;
					margin-right: 20px;
					margin-left: 20px;
					margin-bottom: 32px;
					border-radius: 4px;
					display: inline-block;
					color: $c-slate-dark;
					padding: 0px;
					border-color: black;
					min-height: 19rem;
					max-width: $news-card-width;
					flex-basis: $news-card-width;
					opacity: 0;
					transition: 0.8s opacity ease-in-out;

					.image {
						// background-color: black;
						background-size: cover;
						width: 100%;
						height: 11rem;
						display: none;
					}

					&.lazy-loaded {
						opacity: 1;

						.image {
							display: block;
						}
					}

					.blue-line {
						width: 100%;
						height: 8px;
						background-color: $c-blue;
						margin: 0px;
					}

					.news-card-text {
						width: 100%;
						height: 7.5rem;
						display: flex;
						flex-direction: column;

						h3 {
							font-family: 'Merriweather';
							font-weight: 700;
							font-size: 1rem;
							padding: 10px 30px 4px 30px;
							margin: 0px;
						}

						p {
							font-family: 'Helvetica Neue';
							font-weight: 400;
							font-size: 17px;
							padding: 0px 30px 10px 30px;
							margin: 0px;
							flex: 1;
							overflow: hidden;

							p {
								overflow: hidden;
								max-height: 100%;
								text-overflow: ellipsis;
								margin: 0;
								padding: 0;
							}
						}
					}

					&.double {
						flex-basis: $new-card-double-width;
						max-width: $new-card-double-width;
					}

					&:hover {
						box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
						border-radius: 4px;
						cursor: pointer;

						h3 {
							color: $c-blue;
						}

						.image {
							border-radius: 4px 4px 0px 0px;
						}
					}
				}
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.authenticated-homepage {
			.promo-bar {
				.wrapper {
					padding: 0.5rem 4rem;
				}

				.search-promo {
					flex-direction: row;

					img {
						display: block;
					}
				}
			}
		}
	}
</style>
<template>
	<main class="authenticated-homepage">
		<section class="wrapper card-wrapper">
			<h1 class="news-headline text-centered">Hi, {{ userContext && userContext.firstName }}! {{ headline }}</h1>
			<div class="news-card-layout">
				<template v-for="(item, index) in news">
					<a
						class="news-card"
						:href="item.link"
						:target="item.target"
						:class="{
							double: item.size === 2
						}"
						v-lazy-loader="{
							observer: lazyObserver,
							loaded: index <= loadedCards - 1
						}"
						:loader-index="index"
						@click="onNewsItemClick(item)">
						<figure
							class="image"
							:style="{
								'background-image': 'url(' + item.imgUrl + ')'
							}"></figure>
						<div class="blue-line"></div>
						<div class="news-card-text">
							<h3>{{ item.title }}</h3>
							<p v-html="item.body"></p>
						</div>
					</a>
				</template>
			</div>
		</section>
		<whats-new-modal></whats-new-modal>
	</main>
</template>
